import { render, staticRenderFns } from "./k-json-editor.vue?vue&type=template&id=2fb78900&"
import script from "./k-json-editor.vue?vue&type=script&lang=js&"
export * from "./k-json-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports